import { Controller } from 'stimulus';
import { useTimeout } from '@/js/util';

/**
 * @example Alert that is removed automatically after delay (time is in seconds)
 *   div[data-controller="alert" data-alert-dismiss-timeout-value="5"]
 *     I will be gone after 5 seconds
 */
export default class extends Controller {
  static targets = ['message', 'icon'];

  static values = {
    dismissTimeout: Number,
    icons: Object,
  };

  connect() {
    useTimeout(this);

    if (this.hasDismissTimeoutValue) {
      this.timeout(this.dismissTimeoutValue * 1000, () => this.element.remove());
    }
  }

  show({ detail }) {
    if (detail?.message) {
      this.messageTarget.textContent = detail.message;
    }

    if (detail?.level) {
      this.element.classList.remove(...Object.keys(this.iconsValue).map((name) => `is-${name}`));
      this.element.classList.add(`is-${detail.level}`);
      this.element.setAttribute('role', detail.level === 'error' ? 'alert' : 'status');
      this.iconTarget.className = `fa-solid fa-${this.iconsValue[detail.level]} ui--flash-icon`;
    }

    this.element.classList.remove('hidden');
  }

  dismiss() {
    this.element.classList.add('hidden');
  }
}
